import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
import { CreditFragmentDoc } from '../../../pages/graphql/fragments/TitleDetails.fragment';
export type GetAllCreditsQueryVariables = Types.Exact<{
	fullPath: Types.Scalars['String']['input'];
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
}>;

export type GetAllCreditsQuery = {
	__typename?: 'Query';
	urlV2: {
		__typename?: 'Url';
		id: string;
		node:
			| { __typename?: 'Article'; id: string }
			| { __typename?: 'Author'; id: string }
			| { __typename?: 'Bundle'; id: string }
			| { __typename?: 'Device'; id: string }
			| { __typename?: 'Episode'; id: string }
			| { __typename?: 'GenericTitleList'; id: string }
			| { __typename?: 'Genre'; id: string }
			| { __typename?: 'HomePage'; id: string }
			| {
					__typename?: 'Movie';
					id: string;
					content: {
						__typename?: 'MovieContent';
						credits: Array<{
							__typename: 'Credit';
							role: Types.CreditRole;
							name: string;
							characterName?: string | null;
							personId: number;
							portraitUrl?: string | null;
							profilePath?: string | null;
						}>;
					};
			  }
			| { __typename?: 'MultiStepSportEvent'; id: string }
			| { __typename?: 'Offer'; id: string }
			| { __typename?: 'OfferHistory'; id: string }
			| { __typename?: 'Package'; id: string }
			| { __typename?: 'Page'; id: string }
			| { __typename?: 'Person'; id: string }
			| { __typename?: 'ProfileV2'; id: string }
			| {
					__typename?: 'Season';
					id: string;
					show: {
						__typename?: 'Show';
						id: string;
						content: {
							__typename?: 'ShowContent';
							credits: Array<{
								__typename: 'Credit';
								role: Types.CreditRole;
								name: string;
								characterName?: string | null;
								personId: number;
								portraitUrl?: string | null;
								profilePath?: string | null;
							}>;
						};
					};
			  }
			| {
					__typename?: 'Show';
					id: string;
					content: {
						__typename?: 'ShowContent';
						credits: Array<{
							__typename: 'Credit';
							role: Types.CreditRole;
							name: string;
							characterName?: string | null;
							personId: number;
							portraitUrl?: string | null;
							profilePath?: string | null;
						}>;
					};
			  }
			| { __typename?: 'SingleStepSportEvent'; id: string }
			| { __typename?: 'SportCompetitionV2'; id: string }
			| { __typename?: 'SportCompetitorV2'; id: string }
			| { __typename?: 'SportMatch'; id: string }
			| { __typename?: 'Url'; id: string }
			| { __typename?: 'UserProviderSubscription'; id: string };
	};
};

export const GetAllCreditsDocument = gql`
	query GetAllCredits($fullPath: String!, $country: Country!, $language: Language!) {
		urlV2(fullPath: $fullPath) {
			id
			node {
				id
				... on MovieOrShow {
					content(country: $country, language: $language) {
						... on MovieOrShowContent {
							credits(role: ACTOR) {
								...Credit
							}
						}
					}
				}
				... on Season {
					show {
						id
						content(country: $country, language: $language) {
							credits(role: ACTOR) {
								...Credit
							}
						}
					}
				}
			}
		}
	}
	${CreditFragmentDoc}
`;
